import { render, staticRenderFns } from "./CampiLink.vue?vue&type=template&id=36d5d1fb&scoped=true"
import script from "./CampiLink.vue?vue&type=script&lang=js"
export * from "./CampiLink.vue?vue&type=script&lang=js"
import style0 from "./CampiLink.vue?vue&type=style&index=0&id=36d5d1fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5d1fb",
  null
  
)

export default component.exports